import { render, staticRenderFns } from "./button-back.vue?vue&type=template&id=7c7df776&"
import script from "./button-back.vue?vue&type=script&lang=ts&"
export * from "./button-back.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports